/* eslint-disable jsx-a11y/tabindex-no-positive */
import Box from '@mui/material/Box';
import Grid from '@mui/material/Grid';
import Paper from '@mui/material/Paper';
import { ReactElement } from 'react';
import { useFormContext } from 'react-hook-form';

import { setNoon } from '~/utils/date/date';
import { IDictionaryTypes } from '~/services/api/dictionaries/types';
import DatePicker from '~/ui/components/inputs/DatePicker';
import Select from '~/ui/components/inputs/SelectWithoutAnimation';
import useDictionaryOptions from '~/ui/pages/Clients/LocalAdmin/Form/hooks/useDictionaryOptions';
import { IInitialValues } from '~/ui/pages/Clients/LocalAdmin/Form/initialValues';

import styles from './AdmissionDetails.module.scss';

const AdmissionDetails = (): ReactElement => {
  const {
    control,
    formState: { errors },
  } = useFormContext<IInitialValues>();

  const referralSourceOptions = useDictionaryOptions(IDictionaryTypes.ReferralSource);
  const educationLevelOptions = useDictionaryOptions(IDictionaryTypes.EducationLevel);

  return (
    <div className={styles.marginTop}>
      <Paper>
        <Box sx={{ p: 2 }}>
          <p className={styles.formTitle}>Admission Details</p>
          <Grid container spacing={2}>
            <Grid
              size={{
                sm: 6,
              }}
            >
              <Select
                tabIndex={21}
                options={referralSourceOptions}
                name="admissionDetails.referralSourceId"
                control={control}
                errors={errors}
                label="Referral Source"
                hideSelectedOptions={false}
                openMenuOnFocus
              />
            </Grid>
            <Grid
              size={{
                sm: 6,
              }}
            >
              <DatePicker
                tabIndex={22}
                control={control}
                openTo="date"
                errors={errors}
                maxDate={setNoon(new Date())}
                label="Date of Admission"
                name="admissionDetails.admissionDate"
              />
            </Grid>
            <Grid
              size={{
                sm: 6,
              }}
            >
              <Select
                tabIndex={23}
                options={educationLevelOptions}
                name="educationLevelId"
                control={control}
                errors={errors}
                label="Education Level"
                hideSelectedOptions={false}
                openMenuOnFocus
              />
            </Grid>
          </Grid>
        </Box>
      </Paper>
    </div>
  );
};

export default AdmissionDetails;
